type Translate = (key: string) => string;

export function getTechnicalTooltipMap(t: Translate) {
  return {
    sugars: t('recipes.technicalTooltips.sugars'),
    sml: t('recipes.technicalTooltips.sml'),
    fat: t('recipes.technicalTooltips.fat'),
    totalSolids: t('recipes.technicalTooltips.totalSolids'),
    pac: t('recipes.technicalTooltips.pac'),
  };
}